<template>
    <div>
        <div>
            <h2>Lista de usuários</h2>
        </div>
        <div>
            <b-table striped hover :busy.sync="tableLoading" :items="items" :fields="fields" bordered style="border: 1px solid black;" show-empty>
                <template v-slot:empty="scope">
                    <h4 class="text-center text-info">Sem registros</h4>
                </template>
                <template v-slot:emptyfiltered="scope">
                    <h4 class="text-center text-info">Sem registros para a busca</h4>
                </template>

                <template v-slot:cell(active)="data">
                    {{ data.item.active ? 'Sim' : 'Não' }}
                </template>

                <template v-slot:cell(jobs)="data">
                    {{ data.item.jobs ? data.item.jobs.join(", ") : "" }}
                </template>

                <template v-slot:cell(actions)="data">
                    <!-- {{ data.item.id }} -->
                    <b-button variant="warning" :to="'/users/'+data.item._id.$oid">Editar</b-button>
                    &nbsp;&nbsp;&nbsp;
                    <b-button variant="danger" @click="removeItem(data.item._id)">Deletar</b-button>
                    &nbsp;&nbsp;&nbsp;
                    <b-button variant="success" @click="activate(data.item)">{{ data.item.active ? 'Desativar' : 'Ativar' }}</b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
//import axios from 'axios';
import { getUsers, deleteUser, modifyUser } from './../../configs/services';
import Swal from 'sweetalert2';
import User from './../../models/User';

export default {
    name: 'Users',
    data(){
        return {
            tableLoading: false,
            items: [],
            fields: [
                {
                    key: 'fullname',
                    sortable: true,
                    label: 'Nome'
                },
                {
                    key: 'role',
                    sortable: false,
                    label: 'Função'
                },
                {
                    key: 'email',
                    label: 'E-mail',
                    sortable: true
                },
                {
                    key: 'active',
                    label: 'Usuário Ativo?',
                    sortable: true
                },
                {
                    key: 'country',
                    label: 'País',
                    sortable: true
                },
                {
                    key: 'jobs',
                    label: 'Cargos',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    sortable: false
                }
            ],
        }
    },
    methods: {
        async fetchUsers(){
            this.tableLoading = true;
            try {
                this.items = await User.get();    
            } catch (error) {
                
            }finally{
                this.tableLoading = false;
            }
            
        },
        removeItem(id){
            const vm = this;

            Swal.fire({
                title: 'Tem certeza?',
                text: "Você vai deletar o usuário",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.value) {
                    vm.tableLoading = true;
                    let user = new User({id: id.$oid});
                    user
                    .delete()
                    .then(() => {
                        vm.fetchUsers();
                    });                    
                }
            })

            
        },
        async activate(item){
            const vm = this;
            console.log(item);
            item.id = item._id.$oid;
            item.only_approval = true;
            //item.active = !item.active;
            vm.tableLoading = true;
            let user = new User(item);
            await user.save();
            this.fetchUsers();
            vm.tableLoading = false;
            /**/
        }
    },
    mounted(){
        
        this.fetchUsers();
    }
}
</script>

<style>

</style>